
export var NCCF = [
    {
      id: 0,
      label: 'Listing',
      isChecked: false
    },
    {
      id: 1,
      label: 'Retailer Data',
      isChecked: false
    },
    {
      id: 2,
      label: 'Nccf Bid Data',
      isChecked: false
    }
  ]
  